module.exports = __webpack_public_path__ + "static/img/graphswiper4.669818b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/graphswiper4.png
// module id = oZ7H
// module chunks = 170